import type { SurroundConfig, ViewLimits } from '../types.ts';

export const SURROUND_MIN_ZOOM = 12;

/**
 * Overrides viewLimits minimum zoom to ensure surround tiles are properly loaded and visible.
 * Otherwise defaults to default app config view limits.
 *
 * @param {object} viewLimits - map view limits from config
 * @param {object|falsy} surroundConfig - surround config object, or falsy if disabled
 * @returns {object} updated viewLimits
 */
export const getEffectiveViewLimits = (viewLimits: ViewLimits, surroundConfig?: SurroundConfig | null): ViewLimits => {
  return surroundConfig ? { ...viewLimits, minZoom: SURROUND_MIN_ZOOM } : viewLimits;
};
